// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  redirecturl: 'https://muisca.dian.gov.co/WebIdentidadLogin/?ideRequest=ew0KImNsaWVudElkIjogIk5adUhoZmxHV2dvemd5ejJ1TUhkdjJ5dE1pWWEiLA0KInJlZGlyZWN0X3VyaSI6ICJodHRwczovL211aXNjYS5kaWFuLmdvdi5jby9JZGVudGlkYWRSZXN0X0xvZ2luRmlsdHJvL2FwaS9zdHMvdjEvYXV0aC9jYWxsYmFjaz9yZWRpcmVjdF91cmk9aHR0cHMlM0ElMkYlMkZ3ZWJhenVyZS5kaWFuLmdvdi5jbyUyRmltcG9ydGFjaW9uZXN0ZW1wb3JhbGVzJTJGcG9ydGFsLWJhY2siLA0KInJlc3BvbnNlVHlwZSI6ICIiLA0KInNjb3BlIjogImV4dGVybmFsIiwNCiJzdGF0ZSI6ICIiLA0KIm5vbmNlIjogIiIsDQoicGFyYW1zIjogew0KInRpcG9Vc3VhcmlvIjogImZ1bmNpb25hcmlvIg0KfQ0KfQ%3D%3D',
  sasGeneratorUrl: 'https://apiazure.dian.gov.co/importaciones/temporales',
  baseUrl: 'https://apiazure.dian.gov.co/importaciones/temporales/',
  raiz: '/importacionestemporales',
  dominio: 'webazure.dian.gov.co'
  //raiz: '/',
  //dominio: 'localhost'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
